export default __webpack_public_path__ + "static/media/hoarding2.fbe5d357.png";